import { EMPTY_STRING, ZERO } from "@/constants/commons";
import type { ActionMap, ApiResponseSegcen, ApiResponseSegcenMap, ObjectItemMap, PolicyUserData, SegcenFormat } from "@/interfaces/AccessControl";
import { type UsersResponse } from "@/services/get-user/getUser";

export const mapToAccessControlUser = ({
  auditResponse: {
    idTransaccion,
    codigoRespuesta,
    mensajeRespuesta,
  },
  objectResponse: {
    Objetos,
    Acciones,
  },
}: ApiResponseSegcen): ApiResponseSegcenMap => {
  return {
    auditResponse: {
      transactionId: idTransaccion,
      responseCode: codigoRespuesta,
      responseMessage: mensajeRespuesta,
    },
    objectResponse: {
      objects: Objetos.map(
        ({
          IdObjeto,
          IdAplicacion,
          CodigoObjeto,
          TipoObjeto,
          NombreObjeto,
          DescripcionAplicacion,
          Orden,
          IdObjetoPadre,
          AuditoriaCreacion,
          AuditoriaModificacion,
          NombreObjetoPadre,
        }): ObjectItemMap => ({
          objectId: IdObjeto,
          applicationId: IdAplicacion,
          objectCode: CodigoObjeto.trim(),
          objectType: TipoObjeto,
          objectName: NombreObjeto,
          applicationDescription: DescripcionAplicacion,
          order: Orden,
          parentObjectId: IdObjetoPadre,
          createdAudit: AuditoriaCreacion,
          modifiedAudit: AuditoriaModificacion,
          parentObjectName: NombreObjetoPadre,
        })
      ),
      actions: Acciones.map(
        ({
          IdAccion,
          IdObjeto,
          CodigoAccion,
          NombreAccion,
          SecuenciaAccion,
          Auditable,
          IdTipoAccion,
          CodigoObjeto,
          NombreObjeto,
          Permitido,
        }): ActionMap => ({
          actionId: IdAccion,
          objectId: IdObjeto,
          actionCode: CodigoAccion.trim(),
          actionName: NombreAccion,
          actionSequence: SecuenciaAccion,
          auditable: Auditable,
          actionTypeId: IdTipoAccion,
          objectCode: CodigoObjeto.trim(),
          objectName: NombreObjeto,
          allowed: Permitido,
        })
      ),
    },
  };
};

export const getFormatPermissions = ({ objectResponse }: ApiResponseSegcenMap) => {
  const { objects = [], actions = [] } = objectResponse;

  return objects.reduce((accObjecto, currObjeto) => {
    const currentObjectName = currObjeto.objectCode.trim();
    const hasObjectPrevius = accObjecto[currentObjectName];
    if (!hasObjectPrevius) {
      const actionsByObject = actions.reduce(
        (accAccion, currAccion) =>
          currAccion.objectId === currObjeto.objectId
            ? [...accAccion, currAccion.actionCode.trim()]
            : accAccion,
        [] as string[]
      );
      return {
        ...accObjecto,
        [currentObjectName]: actionsByObject,
      };
    }
    return accObjecto;
  }, {} as SegcenFormat);
};

export const mapToUserData = ({
    codigoCanal: channelCode = ZERO,
    codigoPais: countryCode = ZERO,
    idPoliza: policyId = ZERO,
    codigoOficina: officeCode = EMPTY_STRING,
    codigoVendedor: sellerCode = EMPTY_STRING,
    email = EMPTY_STRING,
    tipoCambio: exchangeRate = ZERO,
    listaPolizas = []
  }: UsersResponse): PolicyUserData => {

  return {
      channelCode,
      countryCode,
      policyId,
      officeCode,
      sellerCode,
      email,
      exchangeRate,
      policyList: listaPolizas.map(({ idPoliza = ZERO, codigoEntidad = EMPTY_STRING, numeroPoliza = EMPTY_STRING, descripcion = EMPTY_STRING }) => ({
        policyId: idPoliza,
        entityCode: String(codigoEntidad),
        policyNumber: numeroPoliza,
        description: String(descripcion)
      }))
    }
};